import * as React from 'react';
import Loader from '../Loader';
import Select, { SelectProps } from 'antd/lib/select';
import withStyles from 'react-jss';
import { Ports } from '../Types/CommonTypes';
import { getPorts } from 'src/api/shipmentTracking';
import { CommonProps } from './common.intefaces';
import { useDebounce } from 'src/hooks/useDebounce';
import { SEARCH_TIMEOUT } from 'src/Library/Constants';
import { isValidArray } from 'src/Library/Helper';
import { commonStyles } from 'src/Library/CommonStyles';
import { StylesProps } from 'src/Library/Types';

const styles = (theme) => ({
  ...commonStyles(theme),
});
interface IProps extends CommonProps, Omit<SelectProps, 'onChange'>, StylesProps<ReturnType<typeof styles>> {
  apiOptions?: PortApiParams;
}

export interface PortApiParams {
  portApi?: 'loadport' | 'dischargeport';
  type?: string[];
  countryCodeList?: string[];
}

const PortFilter = (props: IProps) => {

  const {
    size,
    mode,
    style,
    value,
    classes,
    disabled,
    onChange,
    className,
    apiOptions,
    placeholder,
    dropdownStyle,
  } = props;

  const [ports, setPorts] = React.useState<Ports[]>([]);
  const [searching, setSearching] = React.useState<boolean>(false);
  const [queryString, setQuery] = React.useState<string>('');

  const handlePortSearch = async () => {
    setSearching(true);
    const response = await getPorts({
      queryString,
      type: ['DRY', 'WET', 'AIR'],
      ...(apiOptions || {}),
    });
    setPorts(response?.data || []);
    setSearching(false);
  };

  const debounceTime = useDebounce(queryString, SEARCH_TIMEOUT);
  React.useEffect(() => {
    // Only search if there's actually a query string (not on initial mount with empty string)
    if (debounceTime !== undefined && debounceTime !== '') {
      setSearching(true);
      handlePortSearch();
    }
  }, [debounceTime]);

  const dropdownRender = (menu) => {
    if (searching) return <div
      style={{ padding: '25px' }}>
      <Loader />
    </div>;
    return menu;
  };

  const renderPortOptions = () => {
    return ports?.map((port: Ports) => <Select.Option
      key={port.code}
      {...port}
      data-value={`${port.name} (${port.code})`}
    >
      {`${port.name} (${port.code})`}
      {port.type === 'DRY' && <button
        className={classes.icd}
      >
        ICD
      </button>}
    </Select.Option>) || [];
  };

  const handlePortChange = (ports, options) => {
    /** removing value will reset the options */
    if (!ports && !options) {
      setQuery('');
    }

    if (!onChange) return;
    if (isValidArray(ports)) {
      const selected = options?.map(option => ({
        ...option?.props,
        key: option.code,
        label: `${option.name} (${option.code})`,
      })) || [];
      onChange(selected);
    } else if (ports?.key) {
      onChange({
        ...options?.props,
        ...ports,
      });
    } else {
      onChange(undefined);
    }
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    size={size || 'default'}
    showSearch
    labelInValue
    value={value}
    disabled={disabled}
    className={className}
    onChange={handlePortChange}
    optionLabelProp="data-value"
    mode={mode || 'default'}
    dropdownStyle={dropdownStyle}
    dropdownRender={dropdownRender}
    onSearch={query => setQuery(query)}
    onFocus={() => handlePortSearch()}
    filterOption={(inputValue, option) => true}
    placeholder={placeholder || 'Select Ports(s)'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderPortOptions()}
  </Select>;
};

export default React.memo(withStyles(styles)(PortFilter));
